export default __webpack_public_path__ + "static/individual.prinoth-3f0c4d195a71e04b9732afb57d2c6e97.webp";